import { createSelector } from 'reselect';

import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectWidgetInstanceState = (state: AppStateType) => state.widgetInstance;

export const selectPageScrollValue = createSelector(
  [selectWidgetInstanceState],
  widgetInstance => widgetInstance.pageScrollValue ?? '',
);

export const selectWidgetIframeParentDimension = createSelector(
  [selectWidgetInstanceState],
  state => state.widgetIframeParentDimension,
);

export const selectAIRecommendation = createSelector(
  [selectWidgetInstanceState],
  widgetInstance => widgetInstance.aiRecommendation,
);

export const selectProductInteraction = createSelector(
  [selectWidgetInstanceState],
  widgetInstance => widgetInstance.productInteractionVariant,
);

export const selectTasteMatchProductId = createSelector(
  [selectWidgetInstanceState],
  widgetInstance => widgetInstance.tasteMatchProductId,
);

export const selectIsBlockerLauncherShown = createSelector(
  [selectWidgetInstanceState],
  widgetInstance => widgetInstance.isBlockerLauncherShown ?? false,
);

export const selectIsRedirectToAILauncher = createSelector(
  [selectWidgetInstanceState],
  widgetInstance => widgetInstance.isRedirectToAILauncher ?? false,
);
